import React from "react"; // Optional in modern React, but good to include
import blob from "../images/blob.png";
import { Link } from "react-router-dom";

function Home() {
  const linkls = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItem: "center",
  };

  return (
    <div>
      <header className="py-5">
        {" "}
        {/* Note: Use className instead of class in JSX */}
        <div className="container px-5 pb-5">
          <div className="row gx-5 align-items-center">
            <div className="col-xxl-5">
              <div className="text-center text-xxl-start">
                <div className="badge bg-gradient-primary-to-secondary text-white mb-4">
                  <div className="text-uppercase">
                    .NET C# | React Js | Figma UI/UX
                  </div>
                </div>
                <div className="fs-3 fw-light text-muted">
                  Hi! am Furqaan Mujtahid and i am a
                </div>
                <h1 className="display-3 fw-bolder mb-5">
                  <span className="text-gradient d-inline">
                    Software Developer
                  </span>
                </h1>
                <div className="d-grid gap-3 d-sm-flex justify-content-sm-center justify-content-xxl-start mb-3">
                  <Link
                    to="/Resume"
                    className="btn btn-primary btn-lg px-5 py-3 me-sm-3 fs-6 fw-bolder"
                    href="resume.html"
                  >
                    Resume
                  </Link>
                  <Link
                    to="/Projects"
                    className="btn btn-outline-dark btn-lg px-5 py-3 fs-6 fw-bolder"
                    href="projects.html"
                  >
                    Projects
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xxl-7">
              <div className="d-flex justify-content-center mt-5 mt-xxl-0">
                <div className="profile">
                  <img
                    className="profile-img"
                    src={blob}
                    alt="Profile picture" // Updated alt text
                    onError={(e) => {
                      e.target.src = "fallback-image.png";
                    }} // Optional fallback
                  />
                  {/* Optimized: If SVGs are identical, consider using one and styling with CSS */}
                  <div className="dots-1">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      viewBox="0 0 191.6 1215.4"
                      style={{ enableBackground: "new 0 0 191.6 1215.4" }} // Converted to object for JSX
                      aria-hidden="true" // For accessibility
                    >
                      <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
                        {/* Paths omitted for brevity; include all as in original */}
                        <path d="M227.7,12788.6c-105-35-200-141-222-248c-43-206,163-412,369-369c155,32,275,190,260,339c-11,105-90,213-190,262        C383.7,12801.6,289.7,12808.6,227.7,12788.6z"></path>
                        {/* ... (rest of the paths) */}
                      </g>
                    </svg>
                  </div>
                  {/* Repeat for dots-2, dots-3, dots-4 with the same SVG, or extract to a component */}
                  <div className="dots-2">{/* Same SVG as above */}</div>
                  <div className="dots-3">{/* Same SVG as above */}</div>
                  <div className="dots-4">{/* Same SVG as above */}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section class="bg-light py-5">
        <div class="container px-5">
          <div class="row gx-5 justify-content-center">
            <div class="col-xxl-8">
              <div class="text-center my-5">
                <h2 class="display-5 fw-bolder">
                  <span class="text-gradient d-inline">About Me</span>
                </h2>
                <p class="lead fw-light mb-4">
                  My name is Furqaan Mujtahid and am a .NET Software Developer.
                </p>
                <p class="text-muted">
                  I am a .NET Developer with strong, hands-on experience in C#,
                  ASP.NET Core MVC, and ASP.NET Core Web APIs, specializing in
                  building robust, scalable, and secure server-side
                  applications. My focus is on crafting clean applications,
                  high-performance APIs, and reliable business logic that power
                  enterprise and government-scale platforms. <br />
                  I have contributed to major digital systems for government
                  entities in the UAE—such as Dubai RTA, Crown Prince Court, and
                  Ajman Finance Department—where I helped develop and maintain
                  backend CMS, workflow, and service-driven platforms in
                  fast-paced, security-focused environments.
                  <br />
                  In addition to backend engineering, I work comfortably with
                  frontend frameworks like Angular and React, and I have a
                  strong UI/UX understanding through hands-on experience with
                  Figma for wireframing and prototype design.
                </p>
                <div class="d-flex justify-content-center fs-2 gap-4">
                  <a
                    class="text-gradient"
                    href="https://www.linkedin.com/in/fmujtahid"
                    style={linkls}
                  >
                    <i class="bi bi-linkedin"></i>
                    <span style={{ fontSize: "medium" }}>linkedin</span>
                  </a>
                  <a
                    class="text-gradient"
                    href="https://github.com/fmujtahids"
                    style={linkls}
                  >
                    <i class="bi bi-github"></i>
                    <span style={{ fontSize: "medium" }}>New Github</span>
                  </a>
                  <a
                    class="text-gradient"
                    href="https://github.com/furqaansiddiqui786"
                    style={linkls}
                  >
                    <i class="bi bi-github"></i>
                    <span style={{ fontSize: "medium" }}>Old Github</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
